import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      name: 'Carlos Mendoza',
      company: 'Técnico Express',
      role: 'Gerente General',
      text: 'Desde que usamos el software, organizamos mejor a los técnicos y aumentamos los trabajos un 30%. Ya no perdemos tiempo buscando papeles.',
      rating: 5
    },
    {
      name: 'María González',
      company: 'Frío Total',
      role: 'Directora de Operaciones',
      text: 'La Web móvil para técnicos es excelente. Ahora todos saben exactamente qué hacer y dónde ir. Los clientes están más satisfechos.',
      rating: 5
    },
    {
      name: 'Jorge Ramírez',
      company: 'Electro Service',
      role: 'Propietario',
      text: 'El sistema de reportes nos ayudó a identificar oportunidades de mejora. Facturamos más rápido y tenemos todo organizado.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container">
        <h2 className="section-title">Lo que dicen nuestros clientes</h2>
        <p className="section-subtitle">
          Empresas como la tuya ya están transformando su gestión
        </p>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i}>⭐</span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                  <div className="author-company">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
